import React, { useEffect } from "react";

// Link
import { useNavigate } from "react-router-dom";

// Lib
import { sanitize } from "dompurify";
import { useAppDispatch } from "lib/hooks/useDispatch";

// components
import Img from "components/Img";
import Button from "components/UiKit/Button";

// Actions
import { modalClose } from "reducers/modal";

type PropsType = {
  modalProps?: UnitType
};

type UnitType = {
  text?: string,
  title?: string,
  subTitle?: string,
  actionClose?: any,
  navigate?: any,
};

const SuccessModal: React.FC<PropsType> = ({ modalProps }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    document.body.classList.add("wrapper-success");

    return () => document.body.classList.remove("wrapper-success");
  }, []);

  const handlerOnPress = () => {
    dispatch(modalClose());
    navigate("/auth?tab=sign-in");
  };

  return (<div className="success-modal flex flex-jc-center flex-ai-center flex-direction-column">
    <Img name="success" alt="Success image" className="success-modal__img" />
    {!!modalProps?.title &&
      <h1 className="success-modal__title"
          dangerouslySetInnerHTML={{ __html: sanitize(modalProps.title || "") }} />}
    {!!modalProps?.subTitle && <p className="success-modal__sub-title"
                                         dangerouslySetInnerHTML={{ __html: sanitize(modalProps.subTitle || "") }} />}
    {!!modalProps?.text &&
      <p className="success-modal__text"
         dangerouslySetInnerHTML={{ __html: sanitize(modalProps.text || "") }} />}

    <Button label="Log In" variable="info" onPress={handlerOnPress} />
  </div>);
};

export default SuccessModal;
